import { GETNewsById } from '@fe-news/api/news';
import { ServerStatusCodes } from '@fe-news/constants/server-status-codes';

export const fetchNewsById = async (id: number) => {
  try {
    const response = await GETNewsById({ id });

    if (response.statusCode === ServerStatusCodes.SUCCESS) {
      return response.items as News;
    }
  } catch (error: unknown) {
    const errorMessage = `Http Error: ${(error as Error).message}`;

    console.error(errorMessage);
    return {} as News;
  }
  return {} as News;
};
